
const UPDATE_APPLICATION_DATA = (state = {}, action) =>{
    switch(action.type){
        case 'UPDATE_PROCESS' : 
            return {...state , process : action.payload }
            case 'SET_SELECTION_ID' : 
            return {   
                ...state,
                default_filter_object: {
                    ...state.default_filter_object,
                    slec:action.payload
                }
            };  
            case 'SET_PERIOD_BUCKET' : 
            return {   
                ...state,
                default_filter_object: {
                    ...state.default_filter_object,
                    DimensionKey: {
                        ...state.default_filter_object.DimensionKey,
                        period: action.payload,
                    }
                }
            };                            
        case 'SET_PRODUCT_LAVAL' : 
        return {   
            ...state,
            default_filter_object: {
                ...state.default_filter_object,
                DimensionKey: {
                    ...state.default_filter_object.DimensionKey,
                    product: action.payload,
                }
            }
        };  
        case 'SET_LOCATION_LAVAL' : 
                return {   
                    ...state,
                    default_filter_object: {
                        ...state.default_filter_object,
                        DimensionKey: {
                            ...state.default_filter_object.DimensionKey,
                            location: action.payload,
                        }
                    }
                };        
        case 'UPDATE_DEFAULT_FILTER_OBJECT' : 
            return {...state , default_filter_object : action.payload}
        case 'SET_PRODUCTS':
                return {   
                    ...state,
                    default_filter_object: {
                        ...state.default_filter_object,
                        DimensionValues: {
                            ...state.default_filter_object.DimensionValues,
                            product: action.payload,
                        }
                    }
                };    
                case 'SET_LOCATIONS':
                    return {   
                        ...state,
                        default_filter_object: {
                            ...state.default_filter_object,
                            DimensionValues: {
                                ...state.default_filter_object.DimensionValues,
                                location: action.payload,
                            }
                        }
                    };     
                    case 'SET_PERIOD':
                        return {   
                            ...state,
                            default_filter_object: {
                                ...state.default_filter_object,
                                DimensionValues: {
                                    ...state.default_filter_object.DimensionKey,
                                    period: action.payload,
                                }
                            }
                        }; 
                        case 'SET_PERIOD_LIST':
                            return {   
                                ...state,
                                default_filter_object: {
                                    ...state.default_filter_object,
                                    DimensionValues: {
                                        ...state.default_filter_object.DimensionValues,
                                        period: action.payload,
                                    }
                                }
                            };  
                            case 'SET_ACTIVE_TAB':
                                return {
                                    ...state,
                                    activeTab: action.payload,
                                };                   
        default : return state
    }
}


export {UPDATE_APPLICATION_DATA}